module.exports = __webpack_public_path__ + "static/media/logoSiege.aa07dac8.png";